import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TemplateManagerService } from 'src/app/services/template-manager.service';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-create-new-template',
  templateUrl: './create-new-template.component.html',
  styleUrls: ['./create-new-template.component.scss']
})
export class CreateNewTemplateComponent implements OnInit,AfterViewInit,OnDestroy{
  textAreaForm = new FormControl('',Validators.required);
  storeTemplateVar:any[] = [];
  templateText:any;
  textArea: any;
  storedText:any;
  spin:boolean = false;
  templateName = new FormControl('',Validators.required);
  @ViewChild('textArea') _textArea: ElementRef;
  regex = /\[(.*?)\]/g;
  private destroy$ = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<CreateNewTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private templateManagerService:TemplateManagerService,
    private snackBar:MatSnackBar
    ) {}

  ngAfterViewInit(): void {
   this.textArea = this._textArea.nativeElement as HTMLTextAreaElement;
  }

  ngOnInit(): void {
    if(this.data.templateData){
      this.templateName.setValue(this.data.templateData.name);
      this.textAreaForm.setValue(this.data.templateData.templateText);
    }
    this.getTemplateVariables();
  }


  action($event){
    if($event == 'Save'){
      this.updateTemplate()
    }else{
      this.close();
    }
  }

  close(){
    this.dialogRef.close();
  }

  getTemplateVariables(){
    this.templateManagerService.getTemplateVariables().pipe(takeUntil(this.destroy$)).subscribe({
    next: (res:any) => {
      if(res){
        this.storeTemplateVar = res;
        this.templateManagerService.storeTemplateVar=res;
      }
    },
    error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 4000,
        horizontalPosition: "center",
        data: {
          title: err.error?.error[0],
          action: "Dismiss",
          type: "error",
        },
      });
     }
   });
  }

  selectTemplate(item) {
    if(this.textArea?.value){
      var start = this.textArea.selectionStart;
      var end = this.textArea.selectionEnd;
      this.storedText = this.textArea?.value.substring(0, start) + ' ' + `[${item.name}]` + ' ' + this.textArea.value.substring(end);
      this.textAreaForm.setValue(this.storedText);
    }else{
      this.storedText = this.textAreaForm?.value ? this.textAreaForm?.value + ' ' +`[${item.name}]` : `[${item.name}]`,
      this.textAreaForm.setValue(this.storedText);
    }
    this.templateManagerService.setPosition(this.textArea,start,item);
  }

  updateTemplate(){
    this.spin = true;
    const formatedStr =this.templateManagerService.formatVarNameWithColumnName(this._textArea.nativeElement.value);
    const payload = {
      templateId: this.data?.templateData?.templateId || 0,
      templateText: formatedStr?.trim(),
      name: this.templateName.value,
      isDefault: this.data.templates?.length == 0 ? true : this.data?.templateData?.isDefault ? this.data?.templateData?.isDefault : false
    }
    let api = this.data.templateData ? this.templateManagerService.updateTemplate(payload) :  this.templateManagerService.addTemplate(payload)
    api.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
      this.spin = false;
      this.dialogRef.close(true);
      },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 4000,
        horizontalPosition: "center",
        data: {
          title: err.error?.error[0],
          action: "Dismiss",
          type: "error",
        },
      });
     }
   });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
